import { nonce } from '../utils/runtime';

async function request(method, url, body, { signal } = {}) {
  const response = await fetch(url, {
    method,
    credentials: 'include',
    signal,
    headers: {
      ...(method !== 'GET' ? { 'Content-Type': 'application/json' } : {}),
      'X-WP-Nonce': nonce
    },
    ...(body !== undefined ? { body: JSON.stringify(body) } : {})
  });

  const text = await response.text();
  let data = null;

  try {
    data = text ? JSON.parse(text) : null;
  } catch (error) {
    data = text;
  }

  if (!response.ok) {
    const message =
      (data && typeof data === 'object' && (data.message || data.error)) ||
      `HTTP ${response.status}`;
    const err = new Error(message);
    err.status = response.status;
    err.payload = data;
    throw err;
  }

  return data;
}

export const apiClient = {
  get(url, options) {
    return request('GET', url, undefined, options);
  },
  post(url, body) {
    return request('POST', url, body);
  },
  patch(url, body) {
    return request('PATCH', url, body);
  },
  delete(url) {
    return request('DELETE', url);
  }
};

export default apiClient;
